import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'

import { connect } from 'react-redux'
import { buildSuggestedDatesParamsKey, buildSuggestedDatesString } from 'lib/search/searchUtils'
import { getSuggestedDates } from 'selectors/offerSelectors'
import { prettyDates } from 'components/Search/utils'
import moment from 'moment'
import PriceRowPriceCaption from 'LuxKit/PricePoints/PriceRowPriceCaption'
import PriceRowPrice from 'LuxKit/PricePoints/PriceRowPrice'
import { useOfferPrice } from 'hooks/Offers/useOfferPrice'

interface MappedStateProps {
  suggestedDates?: App.OfferSuggestedDates
}
export interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  price: number
  duration: number
  filters: App.OfferListFilters
}

function MapViewBedbankPricing(props: Props & MappedStateProps) {
  const {
    offer,
    price,
    duration,
    suggestedDates,
    filters,
  } = props

  const intl = useIntl()
  const hasSuggestedCheckInCheckOut = suggestedDates?.checkIn && suggestedDates?.checkOut

  const hasDates = !!filters?.checkIn

  const fromLabel = intl.formatMessage({
    id: 'e/XgJIxQwK',
    defaultMessage: 'from',
    description: 'Price prefix label in map view bedbank pricing',
  })

  const durationText = useMemo(() => {
    if (hasDates) {
      return prettyDates(moment(filters?.checkIn), moment(filters?.checkOut))
    }
    if (!duration) {
      return fromLabel
    }
    if (hasSuggestedCheckInCheckOut) {
      return intl.formatMessage(
        {
          id: '4iHhPuJxvf',
          defaultMessage: '{dates} from',
          description: 'Suggested dates with from prefix in map view bedbank pricing',
        },
        { dates: buildSuggestedDatesString(suggestedDates.checkIn, suggestedDates.checkOut) },
      )
    }
    return intl.formatMessage(
      {
        id: 'rRBhNThtFc',
        defaultMessage: '{nights, plural, one {# night} other {# nights}} from',
        description: 'Night count with from prefix in map view bedbank pricing',
      },
      { nights: duration },
    )
  }, [duration, filters?.checkIn, filters?.checkOut, hasDates, hasSuggestedCheckInCheckOut, suggestedDates?.checkIn, suggestedDates?.checkOut, fromLabel, intl])

  const {
    saleUnit,
    total,
  } = useOfferPrice({
    value: undefined,
    saleUnit: offer.saleUnit,
    duration,
    total: suggestedDates?.price ?? price,
  })

  return <div>
    <PriceRowPriceCaption>{durationText}</PriceRowPriceCaption>
    <PriceRowPrice
      size="S"
      price={total}
      saleUnit={saleUnit}
    />
  </div>
}

export default connect<MappedStateProps, undefined, Props, App.State>((appState, ownProps) => {
  const flexibleSearchFilterKey = buildSuggestedDatesParamsKey(ownProps.filters?.flexibleMonths, ownProps.filters?.flexibleNights, ownProps.filters?.rooms)
  return {
    suggestedDates: getSuggestedDates(appState, flexibleSearchFilterKey, ownProps.offer.id),
  }
})(MapViewBedbankPricing)
